<template>
  <div id="generate-document">
    <GlobalLoading v-if="$store.state.globalLoading" />
    <div class="document-container">
      <div ref="document" class="document-wrapper" style="padding: 0 !important">
        <div
          style="width:100%;height:100%;display:flex;flex-direction:row;align-items:center; justify-content:center; font-size:14px">
          <kplh-template :qr_active="isPdf" :kplh="kplh" :penilaian="penilaian" :kbli="kbli"
            :bidang_usaha_gems="bidang_usaha_gems" />
        </div>
      </div>
    </div>

    <button class="floating-button" @click="exportToPDF">Export to PDF</button>
    <button class="top-floating-button" @click="exportToPDF">
      Export to PDF
    </button>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js'
import axios from 'axios'
import { api, api_lp } from '../../services/config'
export default {
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
    TableDetail: () =>
      import('@/components/molecules/tableDetailPenilaian.vue'),
    KplhTemplate: () => import('@/components/molecules/kplh-template.vue'),
  },
  data() {
    return {
      isVisible: false,
      isLoading: false,
      user: '',
      position: '',
      hoc: '',
      position_hoc: '',
      tableDesc: [
        {
          color: '#FF0000',
          desc1: 'HIGH A',
          desc2: '>80 - 100',
          desc3:
            'Pengadaan Jasa / Barang dengan kategori pekerjaan di area Operasi Tambang, membutuhkan sertifikasi keahlian umum hingga khusus, membutuhkan dokumen IUJP/SIUP, Rencana K3L & Pekerjaan kritis >4 aktifitas.',
          styling1: 'text-sm text-bold column20',
          styling2: 'text-sm column20',
          styling3: 'text-sm column60 col-nohover',
        },
        {
          color: '#FFC000',
          desc1: 'MEDIUM B1',
          desc2: '>50 - &#8804;80',
          desc3:
            'Pengadaan Jasa / Barang dengan kategori pekerjaan di area Operasi Tambang, membutuhkan sertifikasi keahlian umum hingga khusus, membutuhkan dokumen IUJP/SIUP, Rencana K3L & Pekerjaan kritis 2&#8805; - &#8804;4 aktifitas.',
          styling1: 'text-sm text-bold column20',
          styling2: 'text-sm column20',
          styling3: 'text-sm column60 col-nohover',
        },
        {
          color: '#FFFF00',
          desc1: 'MEDIUM - B2',
          desc2: '>35 - &#8804;50',
          desc3:
            'Pengadaan Jasa / Barang dengan kategori pekerjaan di area Operasi Non Tambang, membutuhkan sertifikasi keahlian umum hingga khusus, membutuhkan dokumen SIUP & Pekerjaan kritis &#8804;2 aktifitas.',
          styling1: 'text-sm text-bold column20',
          styling2: 'text-sm column20',
          styling3: 'text-sm column60 col-nohover',
        },
        {
          color: '#00B050',
          desc1: 'LOW - C1',
          desc2: '>20 - &#8804;35',
          desc3:
            'Pengadaan Jasa dengan kategori pekerjaan di area Operasi Non Tambang, membutuhkan sertifikasi keahlian umum hingga khusus, membutuhkan dokumen SIUP.',
          styling1: 'text-sm text-bold column20',
          styling2: 'text-sm column20',
          styling3: 'text-sm column60 col-nohover',
        },
        {
          color: '#92D050',
          desc1: 'LOW - C2',
          desc2: '0 - &#8804;20',
          desc3:
            'Pengadaan Barang dengan kategori pekerjaan di area Operasi Non Tambang, membutuhkan sertifikasi keahlian umum hingga khusus, membutuhkan dokumen SIUP.',
          styling1: 'text-sm text-bold column20',
          styling2: 'text-sm column20',
          styling3: 'text-sm column60 col-nohover',
        },
      ],
      fullRequest: null,
      kplh: null,
      penilaian: null,
      kbli: [],
      bidang_usaha_gems: '',
    }
  },
  created() {
    this.getFullRequest(this.$route.params.id)
  },
  computed: {
    isPdf() {
      const is_pdf = this.$route.path

      return is_pdf.indexOf('pdf') != -1
    },
  },
  methods: {
    async exportToPDF() {
      this.isVisible = true
      await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
      await html2pdf(this.$refs.document, {
        margin: [0.1, 0.1],
        filename: `KPLH-Penilaian-${this.$route.params.vendor}.pdf`,
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 4, dpi: 192, letterRendering: true },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
      })
      this.isVisible = false
      await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
    },
    async getFullRequest(id) {
      try {
        this.$store.commit('SET_GLOBAL_LOADING', true)
        const { data } = await axios({
          method: 'GET',
          url: `${api}/api/v1/request/full-request-kplh/${id}`,
          timeout: 300000
        })

        if (data && data.status == 'success') {
          const result = data.data
          this.kplh = result

          let bidang_usaha_gems = this.$get(
            result,
            'request.kplh_request.bidang_usaha_gems',
            '[]'
          )

          if (bidang_usaha_gems) {
            this.bidang_usaha_gems = JSON.parse(bidang_usaha_gems).map(
              item => item.JENPEK
            )
          }

          let note_1 = this.$get(
            result,
            'request.kplh_penilaian.kplh_note_ah',
            '{}'
          )
          let note_2 = this.$get(
            result,
            'request.kplh_penilaian.kplh_note_i1',
            '{}'
          )
          let note_3 = this.$get(
            result,
            'request.kplh_penilaian.kplh_note_i2',
            '{}'
          )
          let note_4 = this.$get(
            result,
            'request.kplh_penilaian.kplh_note_jm',
            '{}'
          )

          let value_1 = this.$get(
            result,
            'request.kplh_penilaian.kplh_value_ah',
            '{}'
          )
          let value_2 = this.$get(
            result,
            'request.kplh_penilaian.kplh_value_i1',
            '{}'
          )
          let value_3 = this.$get(
            result,
            'request.kplh_penilaian.kplh_value_i2',
            '{}'
          )
          let value_4 = this.$get(
            result,
            'request.kplh_penilaian.kplh_value_jm',
            '{}'
          )

          this.penilaian = {
            ...this.kplh,
            ...JSON.parse(note_1),
            ...JSON.parse(note_2),
            ...JSON.parse(note_3),
            ...JSON.parse(note_4),
            ...JSON.parse(value_1),
            ...JSON.parse(value_2),
            ...JSON.parse(value_3),
            ...JSON.parse(value_4),
          }

          if (result.request.vendor.kbli.length > 0) {
            this.kbli = result.request.vendor.kbli.map(
              item => item.kbli_sub.desc
            )
          }
          await this.$store.commit('SET_GLOBAL_LOADING', false)
        }
      } catch (error) {
        this.$store.commit('SET_GLOBAL_LOADING', false)
      }
    },
  },
}
</script>
